import * as React from "react";
import PropTypes from "prop-types";

import AppContainerBreakpointProvider from "./AppContainerBreakpointProvider";
import AppDrawer from "./AppDrawer";

export const AppContainerContents = (
  { children, drawerChildren, isDrawerRequested, fullscreen, onDrawerClose },
  context
) => {
  const { isLargeAppLayout } = context;

  const handleDrawerRequestChange = () => {
    // Currently we do not have or need a way to open the drawer from here
    if (onDrawerClose) {
      onDrawerClose();
    }
  };

  const style = {
    container: {
      position: "absolute",
      top: 0,
      left: isLargeAppLayout && !fullscreen ? AppDrawer.WIDTH : 0,
      right: 0,
      bottom: 0,
    },
  };

  const drawerOpen = fullscreen ? false : isLargeAppLayout || isDrawerRequested;

  return (
    <div
      data-component-name="AppContainerContents"
      data-app-is-large={isLargeAppLayout}
    >
      <AppDrawer
        docked={isLargeAppLayout}
        onRequestChange={handleDrawerRequestChange}
        open={drawerOpen}
      >
        {drawerChildren}
      </AppDrawer>
      <div
        data-component-section="app-container-main-contents"
        style={style.container}
      >
        {children}
      </div>
    </div>
  );
};

AppContainerContents.contextTypes = {
  isLargeAppLayout: PropTypes.bool,
};

AppContainerContents.propTypes = {
  children: PropTypes.node,
  drawerChildren: PropTypes.node,
  isDrawerRequested: PropTypes.bool,
  onDrawerClose: PropTypes.func,
  fullscreen: PropTypes.bool,
};

export default class AppContainer extends React.Component {
  static propTypes = AppContainerContents.propTypes;

  render() {
    const { children, ...rest } = this.props;

    return (
      <AppContainerBreakpointProvider>
        <AppContainerContents {...rest}>{children}</AppContainerContents>
      </AppContainerBreakpointProvider>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/AppContainer.jsx